import { ApaduaAPI } from './ApaduaAPI';

export class CountriesAPI extends ApaduaAPI {
    resource: string = 'api/countries/';

    getCountries(): Promise<Array<any>> {
        return this.get('') as any;
    }
}
